module.exports = __webpack_public_path__ + "img/highlight_1.1d90ba2f.png";